<template>
  <v-card class="v-modal-new-window analyzed-dialog merge-compare-dialog">
    <!-- [S]  Popup title-->
    <v-card-title class="headline white--text" primary-title>{{ pageTitle }}</v-card-title>
    <v-card-text class="info-section child-table-top-header">
      <v-row class="top-control">
        <!-- <v-col cols="12" class="pb-0 pt-0">
        <v-row>-->
        <v-col cols="12" sm="3" class="pa-0 pt-0 pl-3">
          <span class="float-left">
            <span class="subheader-text">Compare</span>
            <span class="subheader-message"
              >{{ this.countCompare }} {{ this.params[0].MSG_ID }}</span
            >
            <span class="subheader-text">Messages</span>
          </span>
        </v-col>
        <v-col cols="12" sm="9" class="pa-0 pr-3">
          <v-row>
            <v-col cols="12" sm="4" class="pb-0 pt-0 total-text-group">
              <span class="float-left" v-if="this.mode != 'RepositoryMergeView'">
                <span class="subheader-text">Total analyzed EDI File :</span>
                <span class="total-text">{{ this.total_cnt }}</span>
              </span>
            </v-col>
            <v-col cols="12" sm="5" class="pb-0 pt-0 text-right">
              <div class="pt-0">
                <span class="filter-text">Not Used</span>
                <toggle-button
                  v-model="filterQuery.not_used"
                  :labels="true"
                  :sync="true"
                  :height="15"
                  :color="{
                    checked: this.checkedColor,
                    unchecked: this.unCheckedColor,
                    disabled: '#CCCCCC',
                  }"
                  :switch-color="{ checked: this.toggleButton, unchecked: this.toggleButton }"
                  @change="toggleFilter"
                />
                <span class="filter-text">Qualifier</span>
                <toggle-button
                  v-model="filterQuery.qualifier"
                  :labels="true"
                  :sync="true"
                  :height="15"
                  :color="{
                    checked: this.checkedColor,
                    unchecked: this.unCheckedColor,
                    disabled: '#CCCCCC',
                  }"
                  :switch-color="{ checked: this.toggleButton, unchecked: this.toggleButton }"
                  @change="toggleFilter"
                />
              </div>
            </v-col>
            <v-col cols="12" sm="3" class="pb-0 pt-0">
              <v-text-field
                v-model="query"
                @input="onFilterMergeCompare"
                class="search-matched-map-list-button custom-form-component search-button compare-merge-input"
                placeholder="Search"
                append-icon="fas fa-search"
                outlined
                height="30"
                dense
                solo
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <!-- </v-row>
        </v-col>-->
      </v-row>
    </v-card-text>
    <v-card-text class="data-section">
      <v-row class="ma-0 pr-0">
        <v-col cols="12" sm="3" class="p-0 mt-0 pr-0">
          <v-row class="tree-panel ml-0 merge-table-content">
            <v-col cols="12" class="text-left pa-0">
              <v-btn
                @click="expandAllTreeView"
                class="expand-all-tree-view-button btn-height-custom"
                dark
                x-small
                tile
                >{{ !expandAll ? 'Expand All' : 'Collapse All' }}</v-btn
              >
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-treeview
                ref="analyzedTreeView"
                v-model="tree"
                :open="open"
                :items="treeItems"
                class="analyzedTree"
                activatable
                open-on-click
              >
                <template v-slot:label="{ item, open }">
                  <div
                    v-if="!item.disabled && typeof item.children != 'undefined'"
                    class="group-has-children-item"
                  >
                    <v-icon small class="mr-1">fa fa-object-group</v-icon>
                    <span class="group-name">{{ item.seg }}</span>
                    - {{ item.req }} - {{ item.loop }}
                  </div>
                  <div
                    v-if="item.disabled && typeof item.children != 'undefined'"
                    class="group-no-children-item"
                  >
                    <v-icon small color="#b9bbb7" class="mr-1">fa fa-object-group</v-icon>
                    <span class="group-name">{{ item.seg }}</span>
                    - {{ item.req }} - {{ item.loop }}
                  </div>
                  <div
                    v-if="typeof item.children == 'undefined' && !item.disabled"
                    class="child-visible-item"
                    @click="itemClick(item)"
                  >
                    <v-icon small class="mr-1">fa fa-cube</v-icon>
                    <span class="child-item">{{ item.seg }}</span>
                    - {{ item.req }} - {{ item.loop }} - {{ item.dataname }}
                  </div>
                  <div
                    v-if="typeof item.children == 'undefined' && item.disabled"
                    class="child-invisible-item"
                  >
                    <v-icon small color="#dbd7db" class="mr-1">fa fa-cube</v-icon>
                    <span class="child-item">{{ item.seg }}</span>
                    - {{ item.req }} - {{ item.loop }} - {{ item.dataname }}
                  </div>
                </template>
              </v-treeview>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="9" class="pt-0 pb-0 pr-0">
          <v-row class="table-panel ml-6 mr-0 merge-table-content">
            <v-table
              ref="merge_table"
              :height="565"
              :isMinHeight="isMinHeight"
              :title-row-height="25"
              :title-rows="titleRows"
              :columns="columns"
              :table-data="mode == 'RepositoryMergeView' ? mergeRepoViewItems : mergeViewItems"
              :column-cell-class-name="columnCellClass"
              :row-class-name="rowClassName"
              :errorContent="'No matching records found'"
              :is-loading="showLoading"
              :row-mouse-enter="rowHover"
              :row-mouse-leave="rowHoverOut"
              :row-click="rowClick"
              :lazy-loading="lazy_loading"
              :select-all="selectAllChange"
              :select-change="selectChange"
              class="v-popup-table compare-merge-table"
              is-horizontal-resize
              width="100%"
            ></v-table>
            <!--                     row-hover-color="#eee"
            row-click-color="#edf7ff"-->
          </v-row>
          <v-row class="pa-0 pl-4 mr-0 merge-button-group">
            <v-col class="pa-0 text-left pl-5" cols="3">
              <v-tooltip top :disabled="!isEnableCreateLayout" :max-width="tooltipWidth">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="btn-tooltip">
                    <v-btn
                      v-if="mode != 'MergeView' && showMergeCompareButton"
                      @click="mergeSave"
                      :disabled="isEnableCreateLayout"
                      class="btn btn-search"
                      tile
                      color="#0082ba"
                    >
                      <v-icon small color="white" class="mr-1">fa fa-object-ungroup</v-icon>
                      {{ select_layout_rows.length > 0 ? 'Save' : 'Merge & Create' }}
                    </v-btn>
                  </div>
                </template>
                <span>{{ $t('msg.customerDataAnalysis.createLayoutTooltipMsg') }}</span>
              </v-tooltip>
              <v-tooltip top :disabled="!isEnableCreateRepoLayout" :max-width="tooltipWidth">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="btn-tooltip">
                    <v-btn
                      v-if="mode == 'RepositoryMergeView' && showMergeRepoCompareButton"
                      @click="mergeSaveRepo"
                      :disabled="isEnableCreateRepoLayout"
                      class="btn btn-search"
                      tile
                      color="#0082ba"
                    >
                      <v-icon small color="white" class="mr-1">fa fa-object-ungroup</v-icon>
                      {{ select_layout_rows.length > 0 ? 'Save' : 'Merge & Save' }}
                    </v-btn>
                  </div>
                </template>
                <span>{{ $t('msg.customerDataAnalysis.createLayoutTooltipMsg') }}</span>
              </v-tooltip>
            </v-col>
            <v-col class="pa-0 text-right" cols="9">
              <v-btn class="btn btn-excel" tile dark @click="generateExcelFile">
                <v-icon small color="white" class="mr-1">far fa-file-excel</v-icon>Excel
              </v-btn>
              <v-btn class="btn btn-delete" tile dark @click="closePopup">
                <v-icon small color="white" class="mr-1">fa fa-times</v-icon>Close
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <dialogWindow
      ref="processStatusCheck"
      size="max"
      title="Process Status Check"
      detail="Please check process Status Check! All of selected rows status must be 'Layout created!','Uploaded!','Matching Completed!' "
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="processInserted"
      size="max"
      title="Process Inserted"
      detail="Layout has been created successfully!"
      color="success"
      @select-ok="closePopup"
    ></dialogWindow>
  </v-card>
</template>
<script>
/* globals Store */
import { mapState } from 'vuex';
import { MsgTreeParser } from '@/vue-dlb/utils/msgtree_parser';
import $ from 'jquery';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import cfg from '@/vue-caas/config/config.js';

import {
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress,
} from '@/vue-dlb/utils/sys-util.js';

const msgtreeParser = new MsgTreeParser();

export default {
  components: {
    dialogWindow,
  },
  name: 'merge-compare-dialog',
  // Remove unuse code
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd'],
  computed: {
    ...mapState('layout', {
      segItems: 'segItems',
      mergeViewItems: 'mergeViewItems',
      selectMergeViewItems: 'selectMergeViewItems',
    }),
    ...mapState('repository', {
      segRepoItems: 'segItems',
      mergeRepoViewItems: 'mergeViewItems',
      selectMergeViewRepoItems: 'selectMergeViewItems',
    }),
    /* Remove unuse code
    compare_merge_table_header() {
      return [
        {text : "", value: "checkbox", "colspan" : 1, "rowspan" : 2},
        {text : "Seg.", value : "EFSEGMENT_ID", "colspan" : 1, "rowspan" : 2},
        {text : "Element", value : "ESDATAELEM", "colspan" : 1, "rowspan" : 2},
        {text : "Element Name", value : "ESDATANAME", "colspan" : 1, "rowspan" : 2},
        {text : "Req.", value : "ESREQUIRE", "colspan" : 1, "rowspan" : 2},
        {text : "Type", value : "EFDHTYPE", "colspan" : 1, "rowspan" : 2},
        {text : "Size", value : "EFDHMAXIMUM", "colspan" : 1, "rowspan" : 2},
        {text : "Count", value : "CNT", "colspan" : 1, "rowspan" : 2},
        {text : "Value Info", value : "EFCODEDEFIN", "colspan" : 1, "rowspan" : 2},
        {text : "checkboxcompare1", value : "checkboxcompare", "colspan" : 2, "rowspan" : 1},
        {text : "checkboxcompare2", value : "checkboxcompare", "colspan" : 2, "rowspan" : 1},
        {text : "checkboxcompare3", value : "checkboxcompare", "colspan" : 2, "rowspan" : 1},
        {text : "checkboxcompare4", value : "checkboxcompare", "colspan" : 2, "rowspan" : 1},
        {text : "Element Biz. ID", value : "ELEM_ID", "colspan" : 1, "rowspan" : 2},
        {text : "MIG Name", value : "SEG_ELEM", "colspan" : 1, "rowspan" : 2},
      ]
    }, */
    isEnableCreateLayout() {
      if (this.selectMergeData.length > 0) {
        return false;
      }
      return true;
    },
    isEnableCreateRepoLayout() {
      if (this.selectMergeDataRepo.length > 0) {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      isMinHeight: false,
      lazy_loading: true,
      filterQuery: {
        not_used: false,
        // one_value : false,
        qualifier: false,
        // code : false
      },
      /* Remove unuse code
      numberFormatter: new Intl.NumberFormat('en-US'),
      files: {
        html: 'mdi-language-html5',
        js: 'mdi-nodejs',
        json: 'mdi-json',
        md: 'mdi-markdown',
        pdf: 'mdi-file-pdf',
        png: 'mdi-file-image',
        txt: 'mdi-file-document-outline',
        xls: 'mdi-file-excel',
      },
      analyzed_table_data : [],
      */
      showLoading: false,
      expandAll: false,
      dialog: false,
      checkedColor: '#75C7AF',
      unCheckedColor: '#BFCBD9',
      toggleButton: '#FFFFFF',
      query: '',
      pageTitle: '',
      tree: [],
      open: ['public'],
      treeItems: [],
      showMergeRepoCompareButton: false,
      select_layout_rows: [],
      selectMergeData: [],
      selectMergeDataRepo: [],
      tooltipWidth: 300,
      searchTreeItems: {
        header: [
          'CUST_ID',
          'STR_SNDR',
          'STR_RCVR',
          'MSG_ID',
          'MSG_VER',
          'DAT_TYPE',
          'FR_DAT',
          'TO_DAT',
          'PRCS_STS',
          'LAY_PRCS_NO',
          'ALIAS',
        ],
        data: [
          {
            CUST_ID: '',
            STR_SNDR: '',
            STR_RCVR: '',
            MSG_ID: '',
            MSG_VER: '',
            DAT_TYPE: '',
            FR_DAT: '',
            TO_DAT: '',
            PRCS_STS: '', // in case of DataAnalysis Tree selects all status data
            LAY_PRCS_NO: '',
            ALIAS: '',
          },
        ],
      },
      searchRepositoryTreeItems: {
        header: ['LAY_PRCS_NO', 'ALIAS'],
        data: [],
      },
      insertRepoLayoutMaster: {
        header: [
          'ADMIN_YN',
          'CUST_ID',
          'MSG_SNDR',
          'MSG_RCVR',
          'MSG_STD',
          'MSG_ID',
          'MSG_VER',
          'LAY_PRCS_NO',
        ],
        data: [{}],
      },
      insertLayoutMaster: {
        header: [
          'CUST_ID',
          'STR_SNDR',
          'STR_RCVR',
          'MSG_STD',
          'MSG_ID',
          'MSG_VER',
          'DAT_TYPE',
          'FR_DAT',
          'TO_DAT',
          'PRCS_STS',
          'LAY_PRCS_NO',
        ],
        data: [{}],
      },
      insertLayoutData: {
        header: [
          'SYSSTATUS',
          'ROWID',
          'SELE_YN',
          'ELEM_VAL',
          'GRP',
          'ELEM_ID',
          'CNT',
          'CODE_YN',
          'SEG_ELEM',
          'ESDATAELEM',
          'ESDATANAME',
          'EFDHTYPE',
          'EFLOOP_INDEX',
          'ESNOELEM',
          'POS',
          'EFSEGMENT_ID',
          'EFMAX_USE',
          'ESREQUIRE',
          'EFDHMAXIMUM',
          'EFLOOP_LEVEL',
          'ELEM_NO',
          'SEQ',
          'EFLOOP_ID',
          'EFCODEDEFIN',
        ],
        data: [{}],
      },
      columns: [
        {
          field: 'custome',
          width: 60,
          titleAlign: 'center',
          columnAlign: 'center',
          type: 'selection',
          isFrozen: true,
        },
        { field: 'EFSEGMENT_ID', width: 60, columnAlign: 'center', isFrozen: true },
        { field: 'ESDATAELEM', width: 80, columnAlign: 'center', isFrozen: true },
        { field: 'ESDATANAME', width: 180, columnAlign: 'left', isFrozen: true },
        { field: 'ESREQUIRE', width: 60, columnAlign: 'center', isFrozen: true },
        { field: 'EFDHTYPE', width: 60, columnAlign: 'center', isFrozen: true },
        { field: 'EFDHMAXIMUM', width: 60, columnAlign: 'center', isFrozen: true },
        { field: 'CNT', width: 60, columnAlign: 'center', isFrozen: true },
        { field: 'EFCODEDEFIN', width: 100, columnAlign: 'center', isFrozen: true, isResize: true },
        { field: 'ELEM_ID', width: 130, columnAlign: 'center' },
        { field: 'SEG_ELEM', width: 100, columnAlign: 'center' },
      ],
      titleRows: [
        [
          { fields: ['custome'], title: '', titleAlign: 'center', rowspan: 2 },
          {
            fields: ['EFSEGMENT_ID'],
            title: 'Seg.',
            titleAlign: 'center',
            rowspan: 2,
            newprop: 'newprop',
          },
          { fields: ['ESDATAELEM'], title: 'Element', titleAlign: 'center', rowspan: 2 },
          { fields: ['ESDATANAME'], title: 'Element Name', titleAlign: 'center', rowspan: 2 },
          { fields: ['ESREQUIRE'], title: 'Req', titleAlign: 'center', rowspan: 2 },
          { fields: ['EFDHTYPE'], title: 'Type', titleAlign: 'center', rowspan: 2 },
          { fields: ['EFDHMAXIMUM'], title: 'Size', titleAlign: 'center', rowspan: 2 },
          { fields: ['CNT'], title: 'Count', titleAlign: 'center', rowspan: 2 },
          { fields: ['EFCODEDEFIN'], title: 'Value Info', titleAlign: 'center', rowspan: 2 },
          { fields: ['ELEM_ID'], title: 'Element Biz. ID', titleAlign: 'center', rowspan: 2 },
          { fields: ['SEG_ELEM'], title: 'MIG Name', titleAlign: 'center', rowspan: 2 },
        ],
        [],
      ],
    };
  },

  methods: {
    getMergeViewData() {
      if (this.mode == 'RepositoryMergeView') {
        //[2020-07-09] Apply merge view for repository list screen
        for (let i = 0; i < window.params.length; i++) {
          let data = window.params[i];
          this.searchRepositoryTreeItems.data.push({
            LAY_PRCS_NO: data.LAY_PRCS_NO,
            ALIAS: data.ALIAS,
          });
          setTimeout(() => {
            Store.dispatch(
              'repository/selectMergeCreatedLayout',
              this.searchRepositoryTreeItems,
            ).then(() => {
              this.selectMergeDataRepo = this.selectMergeViewRepoItems;
              this.buildTreeItems();
            });
          }, 1000);
        }
      } else {
        this.searchTreeItems.data = this.params;
        Store.dispatch('layout/getMergedDataBoth', this.searchTreeItems).then(() => {
          this.selectMergeData = this.selectMergeViewItems;
          this.toggleFilter();
          this.buildTreeItems();
        });
      }
    },
    generateExcelFile() {
      let self = this;
      const excel = require('node-excel-export');

      // You can define styles as json object
      const styles = {
        headerDark: {
          fill: {
            fgColor: {
              rgb: 'FF496D94',
            },
          },
          font: {
            color: {
              rgb: 'FFFFFFFF',
            },
            sz: 14,
          },
          alignment: {
            vertical: 'center',
            horizontal: 'center',
          },
        },
      };

      let spec = {};
      let first = this.titleRows[0];
      let second = this.titleRows[1];
      for (let i = 0; i < first.length; i++) {
        if (i == 0) {
          continue;
        }
        let col = first[i];
        if (col.title == 'Compare Value') {
          for (let j = 0; j < second.length; j++) {
            col = second[j];
            spec[col.fields[0]] = {
              displayName: col.title,
              headerStyle: styles.headerDark,
              width: 120,
            };
          }
          continue;
        }
        spec[col.fields[0]] = {
          displayName: col.title,
          headerStyle: styles.headerDark,
          width: 120,
        };
      }

      //Array of objects representing heading rows (very top)
      const heading = [
        [
          { value: 'Seg.', style: styles.headerDark },
          { value: 'Element', style: styles.headerDark },
          { value: 'Element Name', style: styles.headerDark },
          { value: 'Req', style: styles.headerDark },
          { value: 'Type', style: styles.headerDark },
          { value: 'Size', style: styles.headerDark },
          { value: 'Count', style: styles.headerDark },
          { value: 'Value Info', style: styles.headerDark },
          { value: 'Compare Values', style: styles.headerDark },
        ],
      ];
      for (let i = 0; i < second.length - 1; i++) {
        heading[0].push('');
      }
      heading[0].push({ value: 'Element Biz. ID', style: styles.headerDark });
      heading[0].push({ value: 'MIG Name', style: styles.headerDark });

      const merges = [
        { start: { row: 1, column: 1 }, end: { row: 2, column: 1 } },
        { start: { row: 1, column: 2 }, end: { row: 2, column: 2 } },
        { start: { row: 1, column: 3 }, end: { row: 2, column: 3 } },
        { start: { row: 1, column: 4 }, end: { row: 2, column: 4 } },
        { start: { row: 1, column: 5 }, end: { row: 2, column: 5 } },
        { start: { row: 1, column: 6 }, end: { row: 2, column: 6 } },
        { start: { row: 1, column: 7 }, end: { row: 2, column: 7 } },
        { start: { row: 1, column: 8 }, end: { row: 2, column: 8 } },
        { start: { row: 1, column: 9 }, end: { row: 1, column: 8 + second.length } },
        {
          start: { row: 1, column: 9 + second.length },
          end: { row: 2, column: 9 + second.length },
        },
        {
          start: { row: 1, column: 10 + second.length },
          end: { row: 2, column: 10 + second.length },
        },
      ];
      // Create the excel report.
      // This function will return Buffer
      const report = excel.buildExport([
        // <- Notice that this is an array. Pass multiple sheets to create multi sheet report
        {
          name: 'Report', // <- Specify sheet name (optional)
          heading: heading, // <- Raw heading array (optional)
          merges: merges, // <- Merge cell ranges
          specification: spec, // <- Report specification
          data: this.mode == 'RepositoryMergeView' ? this.mergeRepoViewItems : this.mergeViewItems, // <-- Report data
        },
      ]);
      var data = new Blob([report.buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var url = window.URL.createObjectURL(data);
      var a = document.createElement('a');
      a.href = url;
      a.download = 'MergeCompare.xlsx';
      document.body.appendChild(a);
      a.click();
    },
    buildTreeItems() {
      let segItems = this.mode == 'RepositoryMergeView' ? this.segRepoItems : this.segItems;
      this.treeItems = msgtreeParser.parse(segItems)[0].children;
    },
    mergeSave() {
      console.log('--------- mergeSave ----------');
      let statusFlat = true;
      this.insertLayoutMaster.data = this.params;
      this.insertLayoutData.data = this.selectMergeData;
      var insertPayload = [this.insertLayoutMaster, this.insertLayoutData];
      console.log(this.insertLayoutMaster.data.length);
      for (let i = 0; i < this.insertLayoutMaster.data.length; i++) {
        if (
          this.insertLayoutMaster.data[i].PRCS_STS != 'UPLD' &&
          this.insertLayoutMaster.data[i].PRCS_STS != 'LAYO' &&
          this.insertLayoutMaster.data[i].PRCS_STS != 'MAEN'
        ) {
          statusFlat = false;
          break;
        }
      }
      if (statusFlat === true) {
        Store.dispatch('layout/createLayout', insertPayload).then(() => {
          console.log('--------- Inserted ----------');
          this.$refs.processInserted.dialog = true;
        });
      } else {
        this.$refs.processStatusCheck.dialog = true;
      }
    },
    mergeSaveRepo() {
      console.log('--------- mergeSaveRepo ----------');
      this.insertRepoLayoutMaster.data = this.params;
      this.insertLayoutData.data = this.selectMergeDataRepo;
      var insertPayload = [this.insertRepoLayoutMaster, this.insertLayoutData];

      Store.dispatch('repository/layoutMergeSave', insertPayload).then(() => {
        console.log('--------- Inserted ----------');
        this.$refs.processInserted.dialog = true;
      });
    },
    async itemClick(item) {
      let self = this;
      await this.$nextTick(() => {
        this.showLoading = true;
        this.$refs.merge_table.$forceUpdate();
      });
      await this.delay(100);
      await this.$nextTick();
      this.lazy_loading = false;
      await this.$nextTick();
      this.showLoading = false;
      setTimeout(() => {
        let items =
          self.mode == 'RepositoryMergeView' ? self.mergeRepoViewItems : self.mergeViewItems;
        for (let i = 0; i < items.length; i++) {
          if (items[i].EFSEGMENT_ID === item.seg) {
            $('.compare-merge-table .v-table-rightview-special-border').scrollTop(i * 40);
            return;
          }
        }
        alert('Item not exist in table');
      }, 300);
    },

    delay: (ms) =>
      new Promise((res) => {
        setTimeout(res, ms);
      }),

    async loadIt() {
      this.isLoading = true;

      // wait for vdom -> dom
      await this.$nextTick();

      // force browser to rerender dom
      // by requesting some property
      // from newly created node
      let width = this.$refs.hey.width;

      // wait for some time, of course
      // higher than monitor refresh rate
      await this.delay(40);

      this.isDone = true;
      this.isLoading = false;
    },
    columnCellClass(rowIndex, columnName, rowData) {
      if (columnName == 'EFSEGMENT_ID') {
        return 'seg-col';
      }
      if (columnName == 'CNT') {
        return 'cnt-col';
      }
      return `${columnName}-col`;
    },
    rowClassName(index, item) {
      let { val, cnt } = this.columnCompare[0];
      for (let i = 1; i < this.columnCompare.length; i++) {
        let col = this.columnCompare[i];
        if (item[val] != item[col.val]) {
          return 'different-layout-row';
        }
      }
      return '';
    },
    selectAllChange(selection, data) {
      this.selectMergeData = selection;
      if (this.mode == 'RepositoryMergeView') {
        this.selectMergeDataRepo = selection;
      }
    },
    selectChange(selection, data) {
      this.selectMergeData = selection;
      if (this.mode == 'RepositoryMergeView') {
        this.selectMergeDataRepo = selection;
      }
    },
    /* Remove unuse code
    removeDialog (dialog) {
        dialog.id = this.id;
        this.closeDialog(dialog);
    },
    selectDialog (obj) {
        this.dragStart(obj);
    },
    dialogDragEnd (obj) {
        this.dragEnd(obj);
    },
    selectOk() {
            this.$emit("select-ok", this.dataValue);
            this.dialog = false;
    },
    selectClose() {
      this.$emit("select-close", this.dataValue);
      this.dialog = false;
    },
    formatNumber(num) {
      return this.numberFormatter.format(num);
    },
    generateHTML(item) {
      let {name} = item;
      let arrStr = name.split(" - ");
      let data = {};
      // name req value text
      if (name.startsWith('Group')) {
        data['name'] = arrStr[0].split(" ")[2];
        data['req'] = arrStr[1];
        data['value'] = arrStr[2];
      } else {
        data['name'] = arrStr[0];
        data['req'] = arrStr[1];
        let sepIndex = arrStr[2].search(" ");
        data['value'] = arrStr[2].substr(0, sepIndex);
        data['text'] = arrStr[2].substr(sepIndex);
      }
      item['data'] = data;
    },
    selectItemChange(item) {
      let checked = item.checked;
      if (checked) {
        this.select_layout_rows.push(item);
      } else {
        let index = this.findIndexItem(item);
        if (index != null) {
          this.select_layout_rows.splice(index, 1);
        }
      }
    },
    // selectAllChange(value) {
    //   this.select_layout_rows = [];
    //   for (let i = 0; i < this.compare_merge_table_data.length; i++) {
    //     let item = this.compare_merge_table_data[i];
    //     item.checked = value;
    //     if (value) {
    //       this.select_layout_rows.push(item);
    //     }
    //   }
    // },
    itemHasChecked(item) {
      let index = this.findIndexItem(item);
      return (index != null) ? true : false;
    },
    customSort: function(items, index, isDesc) {
      return items;
    },*/
    expandAllTreeView() {
      this.expandAll = !this.expandAll;
      if (this.expandAll) {
        this.$refs.analyzedTreeView.updateAll(this.expandAll);
      } else {
        this.$set(this, 'treeItems', []);
        this.$nextTick(() => {
          let segItems = this.mode == 'RepositoryMergeView' ? this.segRepoItems : this.segItems;
          this.$set(this, 'treeItems', msgtreeParser.parse(segItems)[0].children);
        });
      }
    },
    findIndexItem(item) {
      let index = this.select_layout_rows.findIndex((row) => {
        return row.id === item.id;
      });
      return index > -1 ? index : null;
    },
    onFilterMergeCompare(str) {
      this.showLoading = true;
      if (this.mode == 'RepositoryMergeView') {
        setTimeout(() => {
          Store.dispatch('repository/setFilterMergeCompare', {
            query: str,
            filterQuery: this.filterQuery,
          }).then(() => {
            this.showLoading = false;
            this.$refs.merge_table.$forceUpdate();
          });
        }, 300);
      } else {
        setTimeout(() => {
          Store.dispatch('layout/setFilterMergeCompare', {
            query: str,
            filterQuery: this.filterQuery,
          }).then(() => {
            this.showLoading = false;
          });
        }, 300);
      }
    },
    toggleFilter(str) {
      this.showLoading = true;
      if (this.mode == 'RepositoryMergeView') {
        setTimeout(() => {
          Store.dispatch('repository/setFilter', { query: this.filterQuery, str: this.query }).then(
            () => {
              this.showLoading = false;
            },
          );
        }, 300);
      } else {
        setTimeout(() => {
          Store.dispatch('layout/setFilter', { query: this.filterQuery, str: this.query }).then(
            () => {
              this.showLoading = false;
            },
          );
        }, 300);
      }
    },
    rowHover(rowitem) {
      $('.v-table-btable').each(function() {
        if (window.theme) {
          $(this)
            .find('tr')
            .eq(rowitem)
            .addClass('theme--dark-merge-row-hover');
        } else {
          $(this)
            .find('tr')
            .eq(rowitem)
            .addClass('theme--light-merge-row-hover');
        }
      });
    },
    rowClick(rowitem) {
      $('.v-table-btable').each(function() {
        if (window.theme) {
          if (
            $(this)
              .find('tr')
              .hasClass('theme--dark-merge-row-click')
          ) {
            $(this)
              .find('tr')
              .removeClass('theme--dark-merge-row-click');
            $(this)
              .find('tr')
              .eq(rowitem)
              .addClass('theme--dark-merge-row-click');
          } else {
            $(this)
              .find('tr')
              .eq(rowitem)
              .addClass('theme--dark-merge-row-click');
          }
        } else {
          if (
            $(this)
              .find('tr')
              .hasClass('theme--light-merge-row-click')
          ) {
            $(this)
              .find('tr')
              .removeClass('theme--light-merge-row-click');
            $(this)
              .find('tr')
              .eq(rowitem)
              .addClass('theme--light-merge-row-click');
          } else {
            $(this)
              .find('tr')
              .eq(rowitem)
              .addClass('theme--light-merge-row-click');
          }
        }
      });
    },
    rowHoverOut(rowitem) {
      $('.v-table-btable').each(function() {
        if (window.theme) {
          $(this)
            .find('tr')
            .eq(rowitem)
            .removeClass('theme--dark-merge-row-hover');
        } else {
          $(this)
            .find('tr')
            .eq(rowitem)
            .removeClass('theme--light-merge-row-hover');
        }
      });
    },
  },

  created() {
    console.log('--------- created ----------');
    console.log(window.params);
    this.tooltipWidth = cfg.tooltipWidth;
    this.mode = window.mode;
    this.total_cnt = window.total_cnt;
    this.pageTitle = window.pageTitle;
    this.arrParam = window.opener.arrParam;
    if (window.theme) {
      this.$vuetify.theme.dark = true;
      this.checkedColor = '#38BA5C';
      this.unCheckedColor = '#292C35';
      this.toggleButton = '#292C35';
    } else {
      this.$vuetify.theme.dark = false;
      this.checkedColor = '#75C791';
      this.unCheckedColor = '#D0D4DD';
      this.toggleButton = '#FFFFFF';
    }
    this.countCompare = window.params.length;
    let index = 9;
    let index_first_row = 9;
    let index_second_row = 0;
    let arrFirstRow = [];
    this.columnCompare = [];
    this.showMergeCompareButton = true;
    let arrStatus = ['UPLD', 'LAYO', 'MAEN'];
    for (let i = 0; i < window.params.length; i++) {
      let sender = window.params[i].STR_SNDR;
      let receiver = window.params[i].STR_RCVR;
      let alias = window.params[i].ALIAS;
      let status = window.params[i].PRCS_STS;
      if (this.mode == 'RepositoryMergeView') {
        sender = window.params[i].MSG_SNDR;
        receiver = window.params[i].MSG_RCVR;
      }
      if (!arrStatus.includes(status)) {
        this.showMergeCompareButton = false;
      }
      this.columns.splice(index++, 0, { field: `${alias}_VAL`, width: 120, columnAlign: 'center' });
      this.columns.splice(index++, 0, { field: `${alias}_CNT`, width: 60, columnAlign: 'center' });

      this.columnCompare.push({
        val: `${alias}_VAL`,
        cnt: `${alias}_CNT`,
      });
      arrFirstRow.push(`${alias}_VAL`);
      arrFirstRow.push(`${alias}_CNT`);

      let secondTitleRow = this.titleRows[1];
      secondTitleRow.splice(index_second_row++, 0, {
        fields: [`${alias}_VAL`],
        title: `${sender}_${receiver}`,
        titleAlign: 'center',
        titleCellClassName: 'compare-header',
      });
      secondTitleRow.splice(index_second_row++, 0, {
        fields: [`${alias}_CNT`],
        title: 'Count',
        titleAlign: 'center',
        titleCellClassName: 'compare-header',
      });
    }
    if (this.mode == 'RepositoryMergeView') {
      for (let i = 0; i < window.params.length; i++) {
        let status = window.params[i].PRCS_STS;
        if (status != 'REPO') {
          this.showMergeRepoCompareButton = false;
        }
        this.showMergeRepoCompareButton = true;
      }
    }
    let firstTitleRow = this.titleRows[0];
    firstTitleRow.splice(index_first_row++, 0, {
      fields: arrFirstRow,
      title: 'Compare Value',
      titleAlign: 'center',
      colspan: arrFirstRow.length,
      titleCellClassName: 'compare-header',
    });
    this.params = window.params;
    this.getMergeViewData();
  },
  watch: {
    mergeViewItems: function(data) {
      this.selectMergeData = this.mergeViewItems;
    },
  },

  mounted() {
    setTimeout(() => {
      document.getElementsByClassName('overlay-background')[0].style.display = 'none';
    }, 1000);
  },
};
</script>

<style>
.compare-merge-table {
  min-height: 600px;
}
/*
.compare-merge-tabl .v-table-body {
   min-height: 418px;
}
.compare-merge-table .table-title {
  font-weight: bold;
}
.compare-merge-table .compare-checkbox.v-input--selection-controls i {
  color: #223596 !important;
}
.compare-merge-table .v-table-btable .different-layout-row {
  background : #FBBFC6 !important;
}
.title-cell-class-name-test1 {
    background-color: #2db7f5;
}
.title-cell-class-name-test2 {
    background-color: #f60;
}
.merge-compare-dialog .info-section {
  padding-top: 0px !important;
} */
.search-matched-map-list-button.custom-form-component.search-button {
  margin-top: 0px !important;
}
.merge-compare-dialog .analyzedTree.v-treeview {
  height: 530px !important;
}
.merge-compare-dialog .tree-panel {
  min-height: auto !important;
}
.compare-merge-table .v-table-btable div.v-table-body-cell {
  font-size: 11px;
}
.merge-table-content {
  padding: 20px 16px 15px 16px !important;
}
.merge-button-group {
  margin-top: 10px;
}
.total-text-group {
  padding-left: 55px;
}
.top-control div.col-12 {
  line-height: 29px;
}
.merge-compare-dialog .v-table-empty-scroll {
  min-height: 512px;
}
.compare-merge-table .v-table-body {
  min-height: 513px;
}

/* theme--light */
.theme--light .analyzed-dialog .subheader-text {
  color: #12083f;
}
.theme--light .compare-merge-table .v-table-btable td.seg-col span {
  color: #ba0070;
}
.theme--light .compare-merge-table.v-table-class .v-table-header-inner {
  background: #e4e6e8;
}
.theme--light-merge-row-hover {
  background: #eee !important;
}
.theme--light-merge-row-click {
  background: #edf7ff !important;
}

/* theme--dark */
.theme--dark .analyzed-dialog .subheader-text {
  color: #bbbbbb;
}
.theme--dark .compare-merge-table .v-table-btable td.seg-col span {
  color: #ffa6db;
}
.theme--dark .v-table-views.compare-merge-table {
  border: 1px solid #595b64;
}
.theme--dark .merge-table-content .v-table-views {
  background: #292c35 !important;
}
.theme--dark .analyzedTree.v-treeview {
  overflow-y: auto;
}
.theme--dark .compare-merge-table.v-table-class .v-table-header-inner {
  background: #595b64;
}
.theme--dark-merge-row-hover {
  background: #243645 !important;
}
.theme--dark-merge-row-click {
  background: #191a21 !important;
}
.theme--dark .compare-merge-table .v-table-rightview .v-table-body {
  background-color: rgb(41, 44, 53);
}
</style>
